import camelCase from 'lodash-es/camelCase'
import { mapperModuleMedia } from '#layers/core/data-layer/modules/mappers'
import type { MapperOptions } from '#layers/core/types'

export default (data: any, options: MapperOptions) => {
  options.labels
  if (!data) {
    return null
  }

  return {
    partnerName: data.partnerName || '',
    partnerDescription: data.partnerDescription || '',
    partnerLogo: data.partnerLogo ? mapperModuleMedia(data.partnerLogo, options.imageOptions) : null,
    accreditationStatus: data.accreditationStatus?.length
      ? data.accreditationStatus.map((a: any) => options.labels[camelCase(a)]).join(', ')
      : '',
    link: {
      text: data.partnerName,
      url: options.getInternalUrl ? options.getInternalUrl(data.sys?.id) : '',
      nuxt: true,
      openInNewWindow: false
    }
  }
}
